/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import PropTypes from 'prop-types';
import React, { Component } from 'react';

import './ActionStatus.scss';

export default class ActionStatus extends Component<any, any> {
	static propTypes = {
		mode: PropTypes.oneOf(['off', 'polite', 'assertive']),
		status: PropTypes.string,
	};

	static defaultProps = {
		mode: 'polite',
	};

	render() {
		return (
			<div className="bi-common-actionStatus" aria-live={this.props.mode}>
				{this.props.status}
			</div>
		);
	}
}
